class ViewportValues {
  constructor () {
    this._values = {
      width: 0,
      height: 0,
      orientation: 'landscape',
      lastChange: {
        height: 0,
        width: 0,
        orientation: false
      }
    }
  }

  setValues () {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    const orientation = (width > height ? 'landscape' : 'portrait')
    const heightChange = Math.abs(this._values.height - height)
    const widthChange = Math.abs(this._values.width - width)
    const orientationChange = this._values.orientation !== orientation
    this._values = {
      width: width,
      height: height,
      orientation: orientation,
      lastChange: {
        height: heightChange,
        width: widthChange,
        orientation: orientationChange
      }
    }
  }

  update () {
    this.setValues()
  }

  get viewport () {
    return this._values
  }

  get height () {
    return this._values.height
  }

  get width () {
    return this._values.width
  }

  get orientation () {
    return this._values.orientation
  }
}

let instance = new ViewportValues()
export default class Singleton {
  constructor () {
    return instance
  }
}



// WEBPACK FOOTER //
// ./src/utils/viewport/ViewportValues.js